/**
 * @external currencySymbol
 */
/**
 * @external accessibleURL
 * @param URL
 */
/**
 * @external addClassIf
 * @param condition
 * @param element
 * @param classes
 */
/**
 * @external allEmpty
 * @param {...} variable
 */
/**
 * @external allPresent
 * @param {...} variable
 */
/**
 * @external appendElements
 * @param container
 * @param {array[*]} elements
 **/
/**
 * @external anyEmpty
 * @param {...} variable
 */
/**
 * @external anyPresent
 * @param {...} variable
 */
/**
 * @external arrayBatches
 * @param array
 * @oaram [batchSize]
 * @param [returnBatch]
 */
/**
 * @external arrayLast
 * @param array
 */
/**
 * @external assignProp
 * @param object
 * @param propertyStr
 * @param value
 * @param [merge]
 */
/**
 * @external asyncLoop
 * param array
 * param doFunction
 * param wait
 */
/**
 * @external attrIfJQEvent
 * @param valOrEvent
 * @param attr
 * @param [closest]
 */
/**
 * @external attrOr
 * @param element
 * @param attr
 * @param alt
 */
/**
 * @external blacklist
 * @param inputObj
 * @param list
 */
/**
 * @external boolString
 * @param booleanString
 */
/**
 *  @external callWith
 *  @param {function} func
 *  @param value
 */
/**
 * @external camelCase
 * @param string
 * @param [separator]
 */
/**
 *  @external capitalize
 *  @param {String} string
 *  @param {boolean} [words]
 *  @param {boolean} [titleCase]
 */
/**
 * @external castStrTo
 * @param value
 * @param type
 * @param [delimiter]
 */
/**
 * @external checkIconIf
 * @param condition
 * @param [iconClass]
 */
/**
 * @external concatAll
 * @param {...} variable
 */
/**
 * @external conCatStr
 * @param array
 * @param sep
 */
/**
 * @external convertBytes
 * @param value
 * @param {Object} [options]
 * @param {String} [options.to]
 * @param {String} [options.from]
 * @param {Boolean} [options.returnUnit]
 */
/**
 * @external convertCase
 * @param str
 * @param [to]
 * @param [from]
 */
/**
 * @external cloneObj
 * @param object
 **/
/**
 * @external createButton
 * @param text
 * @param {function} [click]
 * @param [classes]
 **/
/**
 * @external createElement
 * @param type
 * @param {*} [classes]
 * @param {*} [content]
 * @param {*} [attrs]
 **/
/**
 * @external createIcon
 * @param value
 */
/**
 * @external createLink
 * @param href
 * @param classes
 * @param contents
 */
/**
 * @external createToggle
 * @param {Object}          [options]
 * @param {Object}          [options.attrs]         - Attributes to add to the checkbox
 * @param {*}               [options.block]         - Text or Elements to but inside the label
 * @param {String|Array}    [options.classes]       - Classes to add to the checkbox
 * @param {Boolean}         [options.onOff]         - Whether the toggle should say On/Off vs Yes/No
 * @param {Boolean}         [options.textBefore]    - Should the label block (content) come before the toggle
 */
/**
 * @external cssVar
 * @param element
 * @param name
 * @param value
 */
/**
 * @external delayWait
 * @param time
 */
/**
 * @external escapeRegExp
 * @param str
 */
/**
 * @external extendObject
 * @param source
 * @param destination
 **/
/**
 * @external fadeIn
 * @param element
 * @param speed
 */
/**
 * @external findAttr
 * @param attr
 * @param element
 */
/**
 * @external fixedNum
 * @param number
 * @param [places]
 */
/**
 * @external forCount
 * @param count
 * @param {Function} doFunction
 */
/**
 * @external forCountAsync
 * @param count
 * @param {Function} doFunction
 */
/**
 * @external forJQLoop
 * @param array
 * @param {function(element, index)} doFunction
 **/
/**
 * @external forLoop
 * @param array
 * @param {Function} doFunction
 * @see forLoopFunc
 * @param {boolean} [JQueryElement]
 **/
/**
 * @external forLoopFunc
 * @param {jQuery|*} element
 * @param [index]
 */
/**
 * @external formatCityStateZip
 * @param [city]
 * @param [state]
 * @param [zip]
 */
/**
 * @external formatDate
 * @param dateStr
 * @param format
 * @param [options]
 */
/**
 * @external formatPhone
 * @param phone
 */
/**
 * @external formatURL
 * @param URL
 * @param [HTTPS]
 * @param [forceHTTPS]
 */
/**
 * @external getAttr
 * @param attr
 * @param element
 * @param [closest]
 */
/**
 * @external getJQElement
 * @param element
 **/
/**
 * @external getJQObj
 * @param unknown
 * @return jQuery
 **/
/**
 * @external getObjProp
 * @param object
 * @param propertyStr
 * @param {*} [altVal]
 */
/**
 * @external getStyle
 * @param element
 * @param style
 */
/**
 * @external getStyles
 * @param element
 */
/**
 * @external getTemplate
 * @param templateId
 * @param {boolean} [returnJQ]
 * @param {boolean} [firstChild]
 */
/**
 * @external getValue
 * @param selector
 */
/**
 * @external getValues
 * @param selector
 */
/**
 * @external hashStr
 * @param str
 */
/**
 * @external hasStyles
 * @param element
 * @param styles
 * @param [checkParents]
 */
/**
 * @external hasUnit
 * @param number
 */
/**
 * @external hexToRGB
 * @param hex
 */
/**
 * @external hideIf
 * @param condition
 * @param element
 */
/**
 * @external hover
 * @param selector
 * @param showHide
 * @param [hide]
 */
/**
 * @external htmlSelectors
 * @param strObj
 * @param prefix
 */
/**
 * @external htmlString
 * @param element
 */
/**
 * @external ifJQEvent
 * @param value
 * @param altValue
 */
/**
 * @external ifSetCall
 * @param func
 * @param {*} [args]
 */
/**
 * @external ifTrueCall
 * @param condition
 * @param func
 * @param [args]
 */
/**
 * @external ignore
 * @param selector
 * @param event
 */
/**
 * @external includes
 * @param needles
 * @param haystack
 * @param [exactMatch]
 */
/**
 * @external intersect
 * @param arr1
 * @param arr2
 */
/**
 * @external isChecked
 * @param checkbox
 */
/**
 * @external isDataURL
 * @param str
 */
/**
 * @external isDefined
 * @param variable
 * @param [properties]
 **/
/**
 * @external isDefinedAs
 * @param variable
 * @param eqVariable
 */
/**
 * @external isDefinedTrue
 * @param variable
 * @param [strict]
 **/
/**
 * @external isElement
 * @param tagName
 * @param element
 */
/**
 * @external isEmpty
 * @param element
 **/
/**
 * @external isJQEvent
 * @param * variable
 */
/**
 * @external isJQObj
 * @param element
 **/
/**
 * @external isNumber
 * @param variable
 **/
/**
 * @external isPlainObject
 * @param variable
 */
/**
 * @external isPresent
 * @param element
 **/
/**
 * @external isPresentOr
 * @param variable
 * @param alternate
 * @param {...} alternates
 */
/**
 * @external isPromise
 * @param variable
 */
/**
 * @external isSetOr
 * @param variable
 * @param alternate
 **/
/**
 * @external isString
 * @param variable
 **/
/**
 * @external isStringOr
 * @param variable
 * @param alternate
 **/
/**
 * @external isTrue
 * @param value
 */
/**
 * @external isUndefined
 * @param variable
 **/
/**
 * @external isURL
 * @param value
 */
/**
 * @external listen
 *  @param selector
 *  @param event
 *  @param {function} method
 *  @param [data]
 */
/**
 * @external logError
 *  @param error
 *  @param [asError]
 */
/**
 * @external loopParents
 * @param element
 * @param function({*} parent) doFunction
 */
/**
 * @external loopProps
 * @param object
 * @param function({string} name[, value]) doFunction
 **/
/**
 *  @external mergeObjects
 *  @param target
 *  @param source
 *  @param [deep]
 */
/**
 *  @external monthAbbr
 *  @param monthName
 *  @param capitalized
 */
/**
 *  @external monthArray
 *  @param abbr
 *  @param capitalized
 */
/**
 *  @external monthLoop
 *  @param doFunction
 *  @param [abbr]
 *  @param [capitalized]
 */
/**
 *  @external monthName
 *  @param monthAbbr
 *  @param capitalized
 */
/**
 * @external numberCommas
 * @param number
 */
/**
 * @external numberOnly
 * @param amount
 */
/**
 * @external numbers
 * @param amount
 * @param [strict]
 */
/**
 * @external objDigest
 * @param obj
 */
/**
 * @external objHasAll
 * @param obj
 * @param props
 */
/**
 * @external objProp
 * @param object
 * @param propertyStr
 * @param {*} [altVal]
 */
/**
 * @external objOrSetProp
 * @param object
 * @param prop
 */
/**
 * @external objType
 * @param obj
 */
/**
 * @external ordinalNumber
 * @param number
 */
/**
 * @external parentHasStyles
 * @param element
 * @param styles
 */
/**
 * @external prefixStringObj
 *  @param prefix
 *  @param strings
 *  @param {*} [newObj]
 */
/**
 * @external pluck
 * @param array
 * @param what
 * Given an array of objects WHAT properties to pluck and return in new array
 */
/**
 * @external pluckUnique
 * @param array
 * @param what
 */
/**
 * @external prependElements
 * @param container
 * @param {array[*]} elements
 **/
/**
 * @external pushIntoProp
 * @param object
 * @param propertyStr
 * @param value
 * @param [concat]
 */
/**
 * @external pushUnique
 * @param target
 * @param source
 */
/**
 * @external radioValue
 * @param name
 */
/**
 * @external removeChar
 * @param str
 * @param characters
 */
/**
 * @external removeEmpty
 * @param array
 */
/**
 * @external replaceElements
 * @param container
 * @param {array[*]} elements
 */
/**
 * @external replaceTokens
 * @param string
 * @param subData
 */
/**
 * @external requestGet
 * @param {string} url
 * @param {*} data
 * @param {function} success
 * @param {function} failure
 */
/**
 * @external requestPost
 * @param {string} url
 * @param {*} data
 * @param {function} success
 * @param {function} failure
 */
/**
 * @external requestSend
 * @param {string} method
 * @param {string} url
 * @param {*} data
 * @param {function} success
 * @param {function} failure
 */
/**
 * @external reStripeTable
 * @param table
 * @param {*} [not]
 * @param {*} [hidden]
 */
/**
 * @external reverseLoop
 * @param array
 * @param {function(element)} doFunction
 * @param {boolean} [JQueryElement]
 */
/**
 * @external rgbToHex
 * @param red
 * @param [green]
 * @param [blue]
 */
/**
 * @external round
 * @param * number
 * @paran * [places]
 */
/**
 * @external sameStr
 * @param var1
 * @param var2
 */
/**
 * @external sameType
 * @param var1
 * @param var2
 */
/**
 * @external scrollToTop
 */
/**
 * @external checkAllCheckboxes
 * @param selector
 * @param values
 */
/**
 * @external setCheckboxes
 * @param name
 * @param values
 */
/**
 * @external setIfDefined
 * @param obj
 * @param prop
 * @param val
 */
/**
 * @external setIfPresent
 * @param obj
 * @param prop
 * @param val
 */
/**
 * @external setStyles
 * @param element
 * @param styles
 */
/**
 * @external showIf
 * @param condition
 * @param element
 */
/**
 * @external showInlineIf
 * @param condition
 * @param element
 */
/**
 * @external spinIcon
 * @param element
 * @param [icon]
 * @param [spin]
 */
/**
 * @external sumArray
 * @param array
 */
/**
 * @external tagName
 * @param element
 */
/**
 * @external toArray
 * @param {*} arrOrStr
 */
/**
 * @external toCurrency
 * @param amount
 * @param [symbol]
 **/
/**
 * @external toggleClass
 * @param condition
 * @param element
 * @param ifTrueClass
 * @param ifFalseClass
 */
/**
 * @external trimChar
 * param str
 * param char
 */
/**
 * @external trimSlashes
 * param path
 */
/**
 * @external truncate
 * @param text
 * @param {number} [length]
 * @param {boolean} [ellipse]
 */
/**
 * @external tryNoCatch
 * @param func
 */
/**
 * @external uniqueArray
 * @param array
 */
/**
 * @external uniqueId
 */
/**
 * @external URLAppendQS
 * @param URL
 * @param qsParams
 */
/**
 * @external validEmail
 * @param email
 */
/**
 * @external validHex
 * @param hex
 */
/**
 * @external validURL
 * @param value
 */
/**
 * @external valIfJQEvent
 * @param valOrEvent
 */
/**
 * @external waitVarPresent
 * @param varNamePropStr
 * @param {*} [object]
 */
/**
 * @external waitVarSet
 * @param varNamePropStr
 * @param {*} [object]
 */
/**
 * @external waitVarTrue
 * @param varNamePropStr
 * @param {*} [object]
 */
/**
 * @external whitelist
 * @param inputObj
 * @param props
 */
/**
 * @external validPhone
 * @param {*} phone
 */
/**
 * @alias Plastic.Helpers
 */
var Helpers = {
    currencySymbol: "$",
    accessibleURL: async function (URL) {
        var valid = true;
        try {
            await Plastic.Request({url: URL});
        } catch (e) {
            valid = false;
        }
        return valid;
    },
    addClassIf: function (condition, element, classes) {
        element = getJQObj(element);
        condition ? element.addClass(classes) : element.removeClass(classes);
    },
    allEmpty: function () {
        return !anyPresent.apply(null, arguments);
    },
    allPresent: function () {
        var present = true;
        forLoop(arguments, variable => {
            present = isPresent(variable);
            if (!present) return true;
        });
        return present;
    },
    anyEmpty: function () {
        var empty = false;
        forLoop(arguments, variable => {
            empty = isEmpty(variable);
            if (empty) return true;
        });
        return empty;
    },
    anyPresent: function () {
        var present = false;
        forLoop(arguments, variable => {
            present = isPresent(variable);
            if (present) return true;
        });
        return present;
    },
    appendElements: function (container, elements) {
        if (isUndefined(container) || isUndefined(elements)) return;
        var isDocFrag = elements.nodeType === Document.DOCUMENT_FRAGMENT_NODE;
        if (isDocFrag) {
            getJQElement(container).appendChild(elements);
            return;
        }

        var fragment = document.createDocumentFragment();
        forLoop(elements, function (element) {            // if (isString(element))  {
            $(fragment).append(element);
        });

        container = getJQElement(container);
        if (isDefined(container)) container.appendChild(fragment);
    },
    arrayBatches: function batch(array, batchSize = 12, returnBatch) {
        var batches = [];
        var batchCount = Math.ceil(array.length / batchSize);

        for (var batchNumber = 1; batchNumber <= batchCount; batchNumber++) {
            let batch = [];

            var offset = (batchSize * batchNumber) - batchSize;
            var limit = Math.min((offset + batchSize), array.length);
            for (var i = offset; i < limit; i++) {
                batch.push(array[i]);
            }
            batches.push(batch);
        }

        if (isPresent(returnBatch)) {
            returnBatch = parseInt(returnBatch);

            // Make sure returnBatch is a valid number
            if (isNaN(returnBatch)) return batches;

            // 0 Index
            returnBatch -= 1;

            // Ensure in bounds
            if (returnBatch < 0) returnBatch = 0;
            if (returnBatch >= batches.length) return []; // Allows for using batch in a loop (when empty all done).

            return batches[returnBatch];
        }
        return batches;
    },
    arrayLast: function (array) {
        if (typeof array.length === "undefined") return;
        return array[array.length - 1];
    },
    assignProp: function (object, propertyStr, value, merge) {
        var props = propertyStr;
        if (!Array.isArray(propertyStr)) {
            props = propertyStr.split(".");
        }

        var lastProp = props.length < 2;
        var prop = props.splice(0, 1)[0];

        if (!isString(prop)) return;

        var plainObj = isPlainObject(object[prop]);

        if (lastProp) {
            if (merge && Array.isArray(object[prop])) {
                if (Array.isArray(value)) {
                    object[prop] = object[prop].concat(value);
                } else object[prop].push(value);
            } else object[prop] = value;
        } else {
            if (!plainObj) object[prop] = {};
            assignProp(object[prop], props, value, merge);
        }
    },
    assignProps: function (object, propValObj) {
        loopProps(propValObj, (name, value) => {
            assignProp(object, name, value);
        });
    },
    asyncLoop: function (array, doFunction, wait = true) {
        // Async version of forLoop
        return new Promise(async function (resolve, reject) {
            if (isUndefined(array)) return reject();
            var promises = [];
            var breakLoop;
            for (var i = 0; i < array.length; i++) {
                var element = array[i];
                if (wait === true) {
                    breakLoop = await doFunction(element, i);
                } else {
                    promises.push(doFunction(element, i));
                }
                if (breakLoop) break;
            }
            if (promises.length > 0) {
                Promise.all(promises).then(resolve).catch(reject);
            } else resolve();
        });
    },
    attrIfJQEvent: function (valOrEvent, attr, closest) {
        return ifJQEvent(valOrEvent, getAttr(attr, objProp(valOrEvent, "target"), closest));
    },
    attrOr: function (element, attr, alt) {
        element = getJQObj(element);
        return isPresentOr(element.attr(attr), alt);
    },
    blacklist: function (inputObj, list) {
        // Returns an object without the given properties
        var output = {};
        if (Array.isArray(inputObj)) {
            output = [];
            forLoop(inputObj, function (element) {
                if (list.indexOf(element) < 0) output.push(element);
            });
        } else {
            loopProps(inputObj, function (prop, value) {
                if (list.indexOf(prop) < 0) output[prop] = value;
            });
        }
        return output;
    },
    boolString: function (booleanString) {
        if (isString(booleanString)) {
            return booleanString === "true";
        } else {
            return booleanString ? "true" : "false";
        }
    },
    callWith: function (func, value) {
        return function () {
            func.bind(this)(value);
        }
    },
    camelCase: function (string, separator = "_") {
        var parts = string.split(separator);
        var output = [];
        forLoop(parts, (part, i) => {
            var temp = parts[i].toLowerCase();
            if (i > 0) {
                temp = capitalize(temp);
            }
            output.push(temp);
        });
        return output.join("");
    },
    capitalize: function (string, words, titleCase) {
        if (!isString(string)) string = "";

        if (words !== true) return uppercase(string);

        var wordArray = string.split(" ");
        return titleCase ? toTitleCase() : wordArray.map(uppercase).join(" ");

        function toTitleCase(){
            const alwaysLowerCase = [
                "a", "an", "and", "as", "at", "but", "by", "en",
                "for", "if", "in", "nor", "of", "on", "or", "per",
                "the", "to", "v", "v.", "vs", "vs.", "via"
            ];

            var output = [];
            var lastWord = wordArray.length - 1;
            forLoop(wordArray, (word, i) => {
                word = word.toLowerCase();
                word = checkSplitWords(word);

                if (i === 0 || i === lastWord) word = uppercase(word);
                else if (!includes(word, alwaysLowerCase)) {
                    word = uppercase(word);
                }

                output.push(word)
            });

            return output.join(" ");

            function checkSplitWords(word){
                // Future update to add more compound word separators:
                const splitSeparators = ["-", "/", ":", "(", "#"];

                forLoop(splitSeparators, separator => {
                    word = capitalizeParts(word, separator);
                });

                return word;

                function capitalizeParts(word, separator){
                    if (word.indexOf(separator) < 0) return word;

                    var parts = word.split(separator);
                    parts = parts.map(uppercase);
                    return parts.join(separator);
                }
            }
        }
        function uppercase(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },
    castStrTo: function (value, type, delimiter = ",") {
        switch (type.toLowerCase()) {
            case "array":
                if (Array.isArray(value)) return value;
                else if (typeof value !== "string") return [];
                else return value.split(delimiter).map(item => item.trim());
            case "boolean":
                if (typeof value === "boolean") return value;
                if (value.toLowerCase() === "true") return true;
                if (value.toLowerCase() === "false") return false;
                return null;
            case "float_array":
            case "int_array":
                if (!Array.isArray(value)) {
                    if (typeof value !== "string") return [];
                    value = value.split(delimiter);
                }
                value = value.map(item => numbers(item, null));
                if (type === "float_array") value = value.map(item => parseFloat(item));
                if (type === "int_array") value = value.map(item => parseInt(item));
                return removeEmpty(value); // Removes NaN
            case "float":
            case "int":
            case "integer":
                value = numbers(value, null);
                return type === "float" ? parseFloat(value) : parseInt(value);
            default:
                return null;
        }
    },
    checkAllCheckboxes: function (selector, value = true) {
        $(selector).prop("checked", value);
    },
    checkIconIf: function (condition, iconClass) {
        iconClass = isPresentOr(iconClass, "fa-check");
        return condition ? createIcon(iconClass) : "";
    },
    // Used to clone object
    cloneObj: function(object){
        if (Array.isArray(object)){
            return JSON.parse(JSON.stringify(object));
        }
        var output = {};
        var props = Object.keys(object);
        forLoop(props, prop => {
            var descriptor = Object.getOwnPropertyDescriptor(object, prop);
            var isGetterSetter = descriptor.set || descriptor.get;
            if (isGetterSetter){
                Object.defineProperty(output, prop, descriptor);
            }
            else if (isPlainObject(object[prop])){
                output[prop] = cloneObj(object[prop]);
            }
            else output[prop] = object[prop];
        });
        return output;
    },
    concatAll: function(){
        var output = [];
        forLoop(arguments, argument => {
            if (isEmpty(argument)) return;
            argument = toArray(argument);
            output = output.concat(argument);
        });
        return output;
    },
    conCatStr: function(array, sep){
        sep = isSetOr(sep, "");
        return removeEmpty(array).join(sep);
    },
    convertBytes: function(input, {to, from, returnUnit = false, places = 2}){
        if (isEmpty(to)) to = findBestTo(input);
        if (isEmpty(from)) from = "b";

        from = from.toLowerCase();
        to = to.toLowerCase();

        var iecUnits = ["eib", "pib", "tib", "gib", "mib", "kib", "bi"];
        var useIEC = includes([to, from], iecUnits);
        var base = useIEC ? 1024 : 1000;

        var outputUnit = to.toUpperCase();

        from    = from.replace("i", "");
        to      = to.replace("i", "");

        var conversion = {
            tb:     {gb: 1,     mb: 2,  kb: 3,  b: 4},
            gb:     {tb: -1,    mb: 1,  kb: 2,  b: 3},
            mb:     {tb: -2,    gb: -1, kb: 1,  b: 2},
            kb:     {tb: -3,    gb: -2, mb: -3, b: 1},
            b:      {tb: -4,    gb: -3, mb: -2, kb: -1}
        }

        var result = fixedNum(input * base ** conversion[from][to], places);

        return returnUnit ? `${result} ${outputUnit}` : result;

        function findBestTo(input){
            var n = 0;
            while (input > 1000){
                input = input / 1000;
                n++;
            }
            return ["b", "kb", "mb", "gb", "tb", "pb", "eb"][n]
        }
    },
    convertCase: function(str, to, from){
        if (isEmpty(str)) return str;

        from = isPresentOr(from, detectCase());
        str = normalize(); // becomes human

        return convert();

        function convert(){
            switch(to){
                case "Camel":
                    str = str.replace(/( )+([A-Za-z])/g, match => match.trim().toUpperCase());
                    return `${str[0].toUpperCase()}${str.substring(1)}`;
                case "camel":
                    str = str.replace(/( )+([A-Za-z])/g, match => match.trim().toUpperCase());
                    return `${str[0].toLowerCase()}${str.substring(1)}`;
                case "kebab": return str.replace(/( )+/g, "-").toLowerCase();
                case "Kebab":
                    str = str.replace(/( )+([A-Za-z])/g, match => `-${match.trim().toUpperCase()}`);
                    return `${str[0].toUpperCase()}${str.substring(1)}`;
                case "snake": return str.replace(/( )+/g, "_").toLowerCase();
                case "Snake":
                    str = str.replace(/( )+([A-Za-z])/g, match => `_${match.trim().toUpperCase()}`);
                    return `${str[0].toUpperCase()}${str.substring(1)}`;
                case "sentence": return capitalize(str);
                case "title": return capitalize(str, true, true);
            }
            return str.toLowerCase();
        }
        function detectCase(){
            if (str.search(/ /) >= 0)           return "human";
            if (str.search(/-[A-Z]/) >= 0)      return "Kebab";
            if (str.search(/-/) >= 0)           return "kebab";
            if (str.search(/_[A-Z]/) >= 0)      return "Snake";
            if (str.search(/_/) >= 0)           return "snake";
            if (str[0].search(/[A-Z]/) >= 0)    return "Camel";
            return "camel";
        }
        function normalize(){
            switch(from){
                case "Camel":
                case "camel": return str.replace(/[A-Z]/g, match => ` ${match}`).trim();
                case "kebab": return str.replace(/-/g, " ");
                case "snake": return str.replace(/_/g, " ");
            }
            return str;
        }
    },
    createButton: function(text, click, classes){
        classes = isSetOr(classes, "");
        var button = createElement("button", classes, text);
        if (isDefined(click)) button.click(click);
        return button;
    },
    createElement: function(type, classes, content, attrs){
        type = type.toLowerCase();
        var element = $(document.createElement(type));
        if (isDefined(classes)) {
            if (Array.isArray(classes)) {
                classes = uniqueArray(classes);
                classes = classes.join(" ");
            }
            element.addClass(classes);
        }

        if (isDefined(content)){
            if (type === "input"){
                element.val(content);
            }
            else if (isArray(content)){
                appendElements(element, content);
            }
            else {
                element.html(content);
            }
        }
        if (isDefined(attrs)){
            loopProps(attrs, function (name, value){
                element.attr(name, value);
            });
        }
        return element;
    },
    createIcon: function(value){
        var iconClasses = ["fa", "fab", "fal", "far", "fas", "fad"];
        if (!includes(iconClasses, value.split(" "))){
            value = "far " + value;
        }
        if (!includes("fa-fw", value.split(" "))){
            value += " fa-fw";
        }
        return createElement("i", value);
    },
    createLink: function(href, classes, contents){
        var a = createElement("a", isPresentOr(classes, ""), isPresentOr(contents, ""));
        a.attr("href", href);
        return a;
    },
    createQueryStr: function (params){
        return Object.keys(params)
            .map(key => [key, params[key]]
                .map(encodeURIComponent).join('=')).join('&');
    },
    createToggle: function({checked = false, classes = "", attrs = {}, onOff = false, block = "", textBefore = false} = {}){
        var checkbox = createElement("input", classes);
        checkbox.attr(attrs);
        checkbox.attr("type", "checkbox");
        checkbox.prop("checked", checked);

        var labelClasses = ["toggle-checkbox"];
        if (onOff) labelClasses.push("on-off");
        return createElement("label", labelClasses, [
            checkbox, labelContents()
        ]);

        function labelContents(){
            var span = createElement("span");

            var contents = [span];
            if (isPresent(block)){
                block = toArray(block);
                if (textBefore) contents = block.push(span);
                else {
                    setStyles(span, {
                        "margin-right": "8px !important"
                    });
                    contents = contents.concat(block);
                }
            }
            return contents;
        }
    },
    cssVar: function(element, name, value){
        element = getJQElement(element);
        if (name.indexOf("--") !== 0){
            name = `--${name}`;
        }

        if (isPresent(value)){ // set value
            element.style.setProperty(name, value);
        }
        else { // return value
            var styles = getStyles(element);
            if (isEmpty(styles)) return;

            return styles.getPropertyValue(name);
        }
    },
    delayWait: function(time){
        return new Promise(function(resolve, reject){
            setTimeout(resolve, time);
        });
    },
    deleteProp: function (object, propertyStr) {
        var props = propertyStr;
        if (!Array.isArray(propertyStr)) {
            props = propertyStr.split(".");
        }

        var lastProp = props.length < 2;
        var prop = props.splice(0, 1)[0];

        if (!isString(prop)) return;

        var plainObj = isPlainObject(object[prop]);

        if (lastProp) delete object[prop];
        else {
            if (!plainObj) return;
            Helpers.deleteProp(object[prop], props);
        }
    },
    escapeRegExp: function(str){
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    },
    equalAny: function(variable, conditionValues){

    },
    extendObject: function(source, destination){
        if (isDefined(source) && isDefined(destination)){
            loopProps(source, function(name, value){
                destination[name] = value;
            });
        }
        return destination;
    },
    fadeIn: async function (element, speed){
        element = getJQObj(element);

        if (speed === 0){
            setStyles(element, {opacity: 1});
            element.show();
            return;
        }

        var stepWait = Math.floor(speed / 100);

        setStyles(element, {opacity: 0});
        element.show();

        await forCountAsync(100, async (step) => {
            setStyles(element, {opacity:  fixedNum(.01 * step)});
            await delayWait(stepWait);
        });

        setStyles(element, {opacity: 1});
    },
    findAttr: function(attr, element){
        // Checks element for attr then children
        element = getJQElement(element);
        var hasAttr = element.hasAttribute(attr);
        if (!hasAttr)$(element).find("[" + attr + "]").attr(attr);
        else return element.getAttribute(attr);
    },
    fixedNum: function(number, places = 2){
        number = numbers(number);
        places = numbers(places);
        return +(number.toFixed(places));
    },
    forJQLoop: function(array, doFunction){
        forLoop(array, doFunction, true);
    },
    forCount: function (count, doFunction){
        var breakLoop;
        for (var i = 0; i < count; i++){
            breakLoop = doFunction(i);
            if (breakLoop) break;
        }
    },
    forCountAsync: async function(count, doFunction){
        var breakLoop;
        for (var i = 0; i < count; i++){
            breakLoop = await doFunction(i);
            if (breakLoop) break;
        }
    },
    forLoop: function(array, doFunction, JQueryElement){
        if (isEmpty(array)) return;
        var breakLoop;
        for (var i = 0; i < array.length; i++){
            var element = JQueryElement ? $(array[i]) : array[i];
            breakLoop = doFunction(element, i);
            if (breakLoop) break;
        }
    },
    formatCityStateZip: function(city, state, zip){
        var output = conCatStr([city, state], ", ");
        return conCatStr([output, zip], " ");
    },
    formatDate: function(dateStr, format, options){
        options = isSetOr(options, {});
        if (isEmpty(dateStr)) return isPresentOr(options["alt"], "");
        var ignoreTZ = isSetOr(options["ignoreTZ"], true);
        var date = Plastic.Time.date(dateStr, ignoreTZ);
        if (date === null){
            return isPresentOr(options["alt"], "");
        }
        return date.format(format);
    },
    formatPhone: function(phone){
        var tmpPhone = numbers(phone, true).toString();
        if (!Helpers.validPhone(tmpPhone)) return phone;

        var line = tmpPhone.slice(-4);
        var prefix = tmpPhone.slice(-7, -4);
        var areaCode = "";
        if (tmpPhone.length > 7){
            areaCode = `(${tmpPhone.slice(-10, -7)}) `;
        }

        return `${areaCode}${prefix}-${line}`;
    },
    formatURL: function(URL, HTTPS = true, forceHTTPS){
        if (!validURL(URL)) return URL;
        var scheme = URL.toLowerCase().substring(0, 5);
        var hasHTTPS = scheme === "https";

        if (hasHTTPS) return URL;

        var hasHTTP = scheme.substring(0, 4) === "http";
        if (hasHTTP) {
            if (!forceHTTPS) return URL;
            return URL.replace(/http:\/\//i, "https://");
        }

        var newScheme = HTTPS || forceHTTPS ? "https://" : "http://";

        var hasColonSlashes = scheme.substring(0, 3) === "://";
        if (hasColonSlashes) return URL.replace("://", newScheme);

        var hasSlashes = scheme.substring(0, 2) === "//";
        if (hasSlashes) return URL.replace("//", newScheme);

        return `${newScheme}${URL}`;
    },
    getAttr: function(attr, element, closest = true){
        element = getJQElement(element);
        if (isUndefined(element)) return;
        var hasAttr = element.hasAttribute(attr);
        if (closest && !hasAttr){
            var parent = $(element).closest(`[${attr}]`);
            if (parent.length > 0) {
                return parent.attr(attr);
            }
        }
        else return element.getAttribute(attr);
    },
    getClasses: function(element){
        element = getJQElement(element);
        if (isEmpty(element.classList)) return [];
        return [...element.classList];
    },
    getJQElement: function(element){
        return isJQObj(element) ? element[0] : $(element)[0];
    },
    getJQObj: function(unknown){
        return isJQObj(unknown) ? unknown : $(unknown);
    },
    getObjProp: function(object, propertyStr, altVal){
        if (isEmpty(object) || Object.keys(object) <= 0){
            return isSetOr(altVal, undefined);
        }

        forLoop(propertyStr.split("."), element => {
            object = object[element];
            if (isEmpty(object)) return true;
        });

        if (isUndefined(object) && isDefined(altVal)) object = altVal;

        return object;
    },
    getStyle: function (element, style){
        return getStyles(element)[style];
    },
    getStyles: function (element){
        element = getJQElement(element);
        if (isUndefined(element)) return {};
        return window.getComputedStyle(element);
    },
    getTemplate: function(templateId, returnJQ, firstChild){
        var template = document.querySelector(templateId);

        // Don't capture error, just let me know which template.
        if (template === null) {
            console.warn(`Template ${templateId} not found.`);
            return;
        }

        var clone = document.importNode(template.content, true);

        if (firstChild) clone = clone.firstElementChild;

        return returnJQ ? $(clone) : clone;
    },
    getValue: function(selector){ // Will get value from first matched element
        var element = getJQObj(selector);
        try {element.val()} catch(e) {return} // catch an issue with this
        switch(element.attr("type")){
            case "checkbox": return isChecked(element);
            case "radio":
                if (element.length <= 1) return isChecked(element);
                else {
                    var value;
                    forLoop(element, radio => {
                        if (isChecked(radio)){
                            value = radio.val();
                            return true;
                        }
                    }, true);
                    return value;
                }
            default: return element.val();
        }
    },
    getValues: function(selector){ // use for named groups (radios, checkboxes, multiple inputs)
        var elements = getJQObj(selector);
        var value = null;
        if (elements.length > 1) value = [];

        forLoop(elements, element => {
            switch(element.attr("type")){
                case "checkbox":
                case "radio":
                    if (isChecked(element)) addValue(element.val());
                    break;
                default:
                    if (isPresent(element.val())) addValue(element.val());
            }
        }, true);

        return value;

        function addValue(val){
            if (Array.isArray(value)) value.push(val);
            else value = val;
        }
    },
    hashId: async function(hashOrNumber, model, length = 8){
        return await Plastic.API({
            data: {
                input: hashOrNumber,
                length: length,
                model: model
            },
            endpoint: "admin/hash"
        });
    },
    hashStr: async function(str){
        var encoder = new TextEncoder();
        var data = encoder.encode(str);
        var hashBuffer = await crypto.subtle.digest('SHA-256', data);
        var hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
    },
    hasStyles: function(element, styles, checkParents = false){
        element = getJQElement(element);

        var elementStyles = getStyles(element);

        var match = true;
        loopProps(styles, (style, value) => {
            var styleValue = elementStyles[style];
            if (isString(styleValue) && isString(value)){
                match = styleValue.toLowerCase() === value.toLowerCase();
            }
            else match = styleValue === value;
            if (!match) return true;
        });
        if (match) return true;

        return parentHasStyles(element, styles);
    },
    hasUnit: function (number){
        return isNaN(number) && number !== numberOnly(number).toString();
    },
    hexToRGB: function(hex){
        hex = trimChar(hex, "#");
        if (!validHex(hex)) return null;
        var values = hex.split('');
        var r, g, b;

        if (hex.length === 3) {
            r = parseInt(values[0].toString() + values[0].toString(), 16);
            g = parseInt(values[1].toString() + values[1].toString(), 16);
            b = parseInt(values[2].toString() + values[2].toString(), 16);
        }
        else if (hex.length === 6) {
            r = parseInt(values[0].toString() + values[1].toString(), 16);
            g = parseInt(values[2].toString() + values[3].toString(), 16);
            b = parseInt(values[4].toString() + values[5].toString(), 16);
        }
        return { red: r, green: g, blue: b };
    },
    hideIf: function(condition, element){
        Helpers.showIf(!condition, element);
    },
    hover: function(selector, showHide, hide){
        hide = isPresentOr(hide, showHide);
        listen(selector, "mouseover", callWith(showHide, true));
        listen(selector, "mouseout", callWith(hide, false));
    },
    htmlSelectors: function(strObj, prefix){
        prefix = isPresentOr(prefix, "");
        var newObj = {};
        var classNameObj = {};
        loopProps(strObj, (name, str) => {
            if (isEmpty(str)) return;
            switch(str.charAt(0)){
                case "#":
                    newObj[name] = `#${prefix}${str.substr(1)}`;
                    break;
                case "[":
                case "*":
                case ":":
                    newObj[name] = str;
                    break;
                default:
                    var hasDot = str.charAt(0) === ".";
                    var className = hasDot ? str.substr(1) : str;
                    var prefixed = `${prefix}${className}`;
                    classNameObj[name] = prefixed;
                    newObj[name] = `.${prefixed}`;
            }
        });
        return [newObj, classNameObj];
    },
    htmlString: function(element){
        element = getJQElement(element);
        if (isDocFrag(element)){
            var el = createElement("div");
            getJQElement(el).appendChild(element.cloneNode(true));
            element = el;
        }

        element = getJQObj(element);
        forLoop(element.find("input"), function(input){
            input.attr("value", input.val());
            input.attr("checked", input.is(":checked"));
        }, true);
        forLoop(element.find("select"), function(select){
            var value = select.val();
            if (isEmpty(value)) return;
            select.attr("value", value);
            var options = select.find("option");
            options.prop("selected", false);
            options.removeAttr("selected", "selected");
            var option = select.find("option[value='" + value.replace(/'/g, "\\'") + "']");
            if (option.length < 1){
                option = select.find(`option:contains("${value}")`);
            }
            option.prop("selected", true);
            option.attr("selected", "selected");
        }, true);
        forLoop(element.find("textarea"), function (textarea){
            textarea.html(textarea.val());
        }, true);
        return element.html();
    },
    ifJQEvent: function(value, altValue){
        // NOTE: if you are having problems with $(this).val() use getValue(this)
        return isJQEvent(value) ? altValue : value;
    },
    ifSetCall: function(func, args){
        if (typeof func === "function"){
            return func.apply(this, toArray(args));
        }
    },
    ifTrueCall: function(condition, func, args){
        if (!condition) return;
        ifSetCall(func, args);
    },
    ignore: function(selector, event){
        $(document).off(event, selector, {}, function(e){e.preventDefault();e.stopImmediatePropagation()});
        $(document).on(event, selector, {}, function(e){e.preventDefault();e.stopImmediatePropagation()});
    },
    includes: function(needles, haystack, exactMatch){
        if (anyEmpty(needles, haystack)) return false;
        if (!Array.isArray(needles)) needles = [needles];
        var found = false;
        forLoop(needles, function(needle){
            found = haystack.indexOf(needle) > -1;
            if (isDefinedTrue(exactMatch) && !found) return true;
            else if (!isDefinedTrue(exactMatch) && found) return true;
        });
        return found;
    },
    intersect: function(arr1, arr2){
        var output = arr1.filter(n => arr2.indexOf(n) !== -1);
        return uniqueArray(output);
    },
    isArray: function(array){
        return Array.isArray(array);
    },
    isChecked: function(checkbox){
        checkbox = getJQObj(checkbox);
        return checkbox.prop("checked");
    },
    isDataURL: function(str){
        if (Helpers.isEmpty(str)) return false;
        return str.indexOf("data:") === 0;
    },
    // Used in conditional to tell if variable is defined
    isDefined: function (variable, properties) {
        var defined = typeof variable !== "undefined";
        if (typeof properties !== "undefined"){
            var object = variable;
            forLoop(properties, function(prop){
                object = object[prop];
                if (typeof object === "undefined"){
                    defined = false;
                    return true;
                }
            });
        }
        return defined;
    },
    isDefinedAs: function(variable, eqValue){
        if (isUndefined(variable)) return false;
        return variable === eqValue;
    },
    isDefinedTrue: function(variable, strict){
        if (isDefined(strict) && strict === true){
            return isDefined(variable) && variable === true;
        }
        else {
            return isDefined(variable) && (variable === true || variable === "true");
        }
    },
    isDocFrag: function(element){
        element = getJQElement(element);
        try {return element.nodeType === Document.DOCUMENT_FRAGMENT_NODE;}
        catch (e){return false}
    },
    isElement: function(tagName, element){
        element = getJQElement(element);
        if (isUndefined(element)) return false;
        if (isUndefined(element.tagName)) return false;
        return element.tagName.toLowerCase() === tagName.toLowerCase();
    },
    isEmpty: function(element){
        return !isPresent(element);
    },
    isFunction: function (variable) {
        return typeof variable === "function";
    },
    isJQEvent: function(variable){
        return variable instanceof jQuery.Event;
    },
    isJQObj: function(element){
        return typeof jQuery === "function" && element instanceof jQuery;
    },
    isNumber: function (variable){
        if (typeof variable !== "number") return false;
        return !isNaN(variable);
    },
    isPlainObject: function(variable) {
        return Object.prototype.toString.call(variable) === "[object Object]";
    },
    isPresent: function(element){
        var present = false;
        if (isDefined(element) && element){
            present = isDefined(element.length) && element.length > 0;
            if (!present){
                if (typeof element === "number"){
                    // typeof NaN === "number" (consider it empty)
                    if (!isNaN(element)) present = true;
                }
                else if (element instanceof Date) present = true;
                else if (typeof element === "boolean") present = true;
                else if (typeof element === "function") present = true;
                else present = Object.keys(element).length > 0;
            }
            else if (isString(element)) {
                // Strings made of just spaces are not present.
                var tempString = element.replace(/\s/g, "");
                present = tempString.length > 0;
            }
        }
        else {
            if (typeof element === "number" && !isNaN(element)) present = true;
            else if (typeof element === "boolean") present = true;
        }
        return present;
    },
    isPresentOr: function(variable, alternate){
        var output = isPresent(variable) ? variable : alternate;
        if (arguments.length < 3 || isPresent(output)) return output;

        for (var i = 2; i < arguments.length; i++){
            output = arguments[i];
            if (isPresent(output)) break;
        }
        return output;
    },
    isPromise: function(variable){
        return variable && typeof variable.then !== "undefined";
    },
    // Returns the variable if it is defined otherwise the alternate
    isSetOr: function(variable, alternate){
        return isDefined(variable) ? variable : alternate;
    },
    isString: function(variable){
        return typeof variable === "string";
    },
    isStringOr: function(variable, alternate){
        return isString(variable) ? variable : alternate;
    },
    isTrue: function(value){
        return value === true || value === "true";
    },
    // Used in conditional to tell if variable is defined
    isUndefined: function (variable) {
        return !isDefined(variable);
    },
    isURL: function(value){ // Just an alias for validURL
        return Helpers.validURL(value);
    },
    listen: function(selector, event, method, data){
        if (isUndefined(method)) return;

        $(document).off(event, selector, data, method);
        $(document).on(event, selector, data, method);
    },
    logError: function(error, asError){
        if (typeof error["stack"] !== "undefined"){
            // error is an instance of the Error object
            console.error(error);
        }
        else {
            var action = asError ? "error" : "log";
            console[action](error);
        }
    },
    loopParents: function(element, doFunction){
        element = getJQElement(element);
        if (element === null) return;

        var parent = element.parentNode;
        if (parent === null || parent === document) return;

        var breakLoop = doFunction(parent);
        if (breakLoop === true) return;
        Helpers.loopParents(parent, doFunction);
    },
    // Loops through only the properties that the object directly has and performs "doFunction" on them
    // Do function should take 2 parameters: property name, and value
    loopProps: function(object, doFunction){
        for (var prop in object){
            var breakLoop;
            if (Helpers.isDefined(object.hasOwnProperty)){
                if (object.hasOwnProperty(prop)){
                    breakLoop = doFunction(prop, object[prop]);
                }
            }
            else {
                breakLoop = doFunction(prop, object[prop]);
            }
            if (breakLoop) break;
        }
    },
    mergeObjects: function(target, source, deep){
        target = cloneObj(target);
        deep = deep === true ? 10 : deep; // Set depth limit
        if (!Helpers.isPlainObject(target) || !Helpers.isPlainObject(source)) return target;
        loopProps(source, (name, value) => {
            var bothObjects = Helpers.isPlainObject(target[name]) && Helpers.isPlainObject(value);
            if (deep > 0 && bothObjects){
                target[name] = Helpers.mergeObjects(target[name], value, deep - 1);
            }
            else {
                target[name] = value;
            }
        });
        return target;
    },
    monthAbbr: function(monthName, capitalized){
        if (isEmpty(monthName)) return "";
        monthName = monthName.toLowerCase();
        var monthAbbr = {
            "january":      "jan",
            "february":     "feb",
            "march":        "mar",
            "april":        "apr",
            "may":          "may",
            "june":         "jun",
            "july":         "jul",
            "august":       "aug",
            "september":    "sep",
            "october":      "oct",
            "november":     "nov",
            "december":     "dec",
        }[monthName];
        monthAbbr = isPresentOr(monthAbbr, "");
        return capitalized ? capitalize(monthAbbr) : monthAbbr;
    },
    monthArray: function(abbr, capitalized){
        var output;
        if (abbr) output = [
            "jan", "feb", "mar", "apr", "may", "jun",
            "jul", "aug", "sep", "oct", "nov", "dec"
        ];
        else output = [
            "january", "february", "march", "april",
            "may", "june", "july", "august", "september",
            "october", "november", "december"
        ];
        if (capitalized) output = output.map(element => capitalize(element));
        return output;
    },
    monthLoop: function(doFunction, abbr, capitalized){
        var months = monthArray(abbr, capitalized);
        var breakLoop;
        for (var i = 0; i < months.length; i++){
            breakLoop = doFunction(months[i], i);
            if (breakLoop) break;
        }
    },
    monthName: function(monthAbbr, capitalized){
        if (isEmpty(monthAbbr)) return "";
        monthAbbr = monthAbbr.toLowerCase();
        var monthName = {
            "jan": "january",
            "feb": "february",
            "mar": "march",
            "apr": "april",
            "may": "may",
            "jun": "june",
            "jul": "july",
            "aug": "august",
            "sep": "september",
            "oct": "october",
            "nov": "november",
            "dec": "december"
        }[monthAbbr];
        monthName = isPresentOr(monthName, "");
        return capitalized ? capitalize(monthName) : monthName;
    },
    numberCommas: function (number){
        if (!isString(number)) number = number.toString();
        var parts = number.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    },
    numberOnly: function(amount){
        if (isString(amount)){
            // catch cases where it is just a hyphen
            if (isEmpty(amount.replace(/[^\d]/g, ""))) return 0;

            amount = amount.replace(/[^\d.-]/g, "");
        }
        return isEmpty(amount) ? 0 : parseFloat(amount);
    },
    numbers: function(amount, strict){
        if (isString(amount)){
            // catch cases where it is just a hyphen
            if (isEmpty(amount.replace(/[^\d]/g, ""))) return 0;

            var regex = strict ? /[^\d]/g : /[^\d.-]/g;
            amount = amount.replace(regex, "");
        }
        return isEmpty(amount) ? 0 : parseFloat(amount);
    },
    objDigest: async function(obj){
        if (typeof obj === "function"){
            // this does not take into consideration closure!!
            return hashStr(obj.toString());
        }

        // Sort object by keys
        var keys = Object.keys(obj).sort();

        // Make profile
        var profileObj = {};
        await asyncLoop(keys, async (key) => {
            var value = obj[key];
            var type = typeof obj[key];
            if (isPlainObject(obj[key])){
                value = await objDigest(obj[key]);
            }
            else if (type === "object" || type === "function") {
                value = objType(obj[key]);
            }
            profileObj[key] = value;
        });

        return hashStr(JSON.stringify(profileObj));
    },
    objHasAll: function(obj, props){
        if (isEmpty(obj)) return false;
        props = toArray(props);
        var hasAll = true;
        forLoop(props, prop => {
            if (isEmpty(obj[prop])) {
                hasAll = false;
                return true; // break loop
            }
        });
        return hasAll;
    },
    objProp: function(object, propertyStr, altVal){
        if (isEmpty(object) || !isPlainObject(object)){
            return isSetOr(altVal, undefined);
        }
        var output = cloneObj(object);
        var props = Array.isArray(propertyStr) ? propertyStr : propertyStr.split(".");
        var propTotal = props.length;
        var passCount = 0;
        forLoop(props, function(element){
            output = output[element];
            passCount++;
            if (passCount !== propTotal && isEmpty(output)){
                output = undefined;
            }
            if (typeof output === "undefined") return true;
        });

        if (typeof output === "undefined" && isDefined(altVal)) output = altVal;

        return output;
    },
    objOrSetProp: function(object, prop){
        if (isArray(object) || typeof object !== "object" || object === null) {
            var obj = {};
            obj[prop] = object;
            return obj;
            // return {[prop]: object};
        }
        return object;
    },
    objType: function(obj){
        return Object.prototype.toString.call(obj);
    },
    ordinalNumber: function(number){
        switch (number){
            case 1: case 21: case 31:   return `${number}st`;
            case 2: case 22:            return `${number}nd`;
            case 3: case 23:            return `${number}rd`;
            default:                    return `${number}th`;
        }
    },
    parentHasStyles: function(element, styles){
        var match = false;

        loopParents(element, (parent) => {
            match = hasStyles(parent, styles);
            return match;
        });

        return match;
    },
    pluck: function(array, what){
        // Given an array of objects WHAT properties to pluck and return in new array
        var output = [];
        forLoop(array, function (element){
            if (isUndefined(element) || isEmpty(element)) return;
            var obj = {};
            if (isArray(what)){
                forLoop(what, function(prop){
                    var value = objProp(element, prop);
                    if (isDefined(value)){
                        obj[prop] = value;
                    }
                });
                output.push(obj);
            }
            else if (isString(what)){
                var value = objProp(element, what);
                if (isDefined(value)){
                    output.push(value);
                }
            }
        });
        return output;
    },
    pluckUnique: function(array, what){
        return uniqueArray(pluck(array, what));
    },
    prefixStringObj: function(prefix, strings, newObj){
        if (newObj) strings = cloneObj(strings);
        loopProps(strings, function(name, value){
            strings[name] = `${prefix}${value}`;
        });
        return strings;
    },
    prependElements: function(container, elements){
        container = getJQObj(container);
        reverseLoop(elements, function(element){
            container.prepend(element);
        });
    },
    pushIntoProp: function(object, propertyStr, value, concat = false){
        var array = Helpers.objProp(object, propertyStr, []);
        array = Helpers.toArray(array);

        concat = concat && Array.isArray(value);
        if (concat) array = array.concat(value);
        else array.push(value);

        Helpers.assignProp(object, propertyStr, array);
    },
    pushUnique: function (target, source){
        target = isPresentOr(target, []);
        source = isPresentOr(source, []);

        var output = target.concat(source);
        return [...new Set(output)];
    },
    radioValue: function(name){
        var radios = $(`[name=${name}]`);
        var value;
        forLoop(radios, radio => {
            if (radio.prop("checked") === true){
                value = radio.val();
                return true;
            }
        }, true);
        return value;
    },
    removeChar(str, characters){
        characters = toArray(characters);
        var needles = [];
        forLoop(characters, character => {
            if (isPresent(character)){
                needles.push(`(${escapeRegExp(character)})`);
            }
        });
        var regex = new RegExp(needles.join("|"), "g");
        return str.replace(regex, "");
    },
    removeEmpty: function(arrayOrObj){
        if (Array.isArray(arrayOrObj)){
            return arrayOrObj.filter(element => {return Helpers.isPresent(element)});
        }
        else {
            var output = {};
            Helpers.loopProps(arrayOrObj, (name, value) => {
                if (Helpers.isPresent(value)) output[name] = value;
            });
            return output;
        }
    },
    replaceElements: function (container, elements) {
        container = getJQObj(container);
        container.html("");
        appendElements(container, elements);
    },
    replaceTokens: function (string, subData){
        if (isEmpty(string)) return string;

        // Future add support for other type of brackets
        loopProps(subData, (prop, value) => {
            var variations = [];
            variations.push(prop.replace(/[- ]/g, "_"));
            variations.push(prop.replace(/[_ ]/g, "-"));
            variations.push(prop.replace(/[_-]/g, " "));
            variations.push(prop.replace(/[ -_]/g, ""));

            variations = variations.join("|");

            var regex = new RegExp(`({{)(\\s)*(${variations})(\\s)*(}})`, "gi");
            value = value.replaceAll("$", "$$$$");
            string = string.replace(regex, value);
        });
        return string;
    },
    reStripeTable(table, not, hidden){
        table = getJQObj(table);
        var trSelector = hidden ? "tr" : "tr:visible";
        if (isPresent(not)) trSelector += `:not(${not})`;

        var odd = table.find(`${trSelector}:odd`);
        var even = table.find(`${trSelector}:even`);

        odd.css({'background-color': '#efefef'});
        even.css({'background-color': '#fff'});
    },
    reverseLoop: function(array, doFunction, JQueryElement){
        if (isUndefined(array)) return;
        for (var i = array.length - 1; i >= 0; i--){
            var element = JQueryElement ? $(array[i]) : array[i];
            doFunction(element, i);
        }
    },
    rgbToHex: function(r, g, b){
        if (r.indexOf("rgb(") === 0){
            var rgb = r;
            rgb = rgb.replace("rgb(", "");
            rgb = rgb.replace(")", "");
            rgb = rgb.split(",")
            r = parseInt(rgb[0].trim());
            g = parseInt(rgb[1].trim());
            b = parseInt(rgb[2].trim());
        }

        // Normalize
        var hexr = Math.max(Math.min(parseInt(r, 10), 255), 0);
        var hexg = Math.max(Math.min(parseInt(g, 10), 255), 0);
        var hexb = Math.max(Math.min(parseInt(b, 10), 255), 0);

        hexr = hexr > 15 ? hexr.toString(16) : `0${hexr.toString(16)}`;
        hexg = hexg > 15 ? hexg.toString(16) : `0${hexg.toString(16)}`;
        hexb = hexb > 15 ? hexb.toString(16) : `0${hexb.toString(16)}`;

        return `#${hexr}${hexg}${hexb}`;
    },
    round: function(number, places){
        places = isSetOr(places, 2);
        number = numberOnly(number);
        places = numberOnly(places);
        return Math.round(number * Math.pow(10, places))/Math.pow(10, places);
    },
    sameStr: function(var1, var2){
        var var1Str = Helpers.isString(var1);
        var var2Str = Helpers.isString(var2);
        if (!var1Str || !var2Str) return false;

        return var1.toLowerCase() === var2.toLowerCase();
    },
    sameType: function(var1, var2){
        return objType(var1) === objType(var2);
    },
    scrollToTop: function(){
        $("html, body").animate({ scrollTop: 0 }, "slow");
    },
    setCheckboxes: function(name, values){
        values = toArray(values);

        forLoop(values, value => {
            var checkbox = $(`[name="${name}"][value="${value}"]`);
            checkbox.prop("checked", true);
        });
    },
    setIfDefined: function(obj, prop, val){
        if (isUndefined(val)) return obj;
        obj[prop] = val;
        return obj;
    },
    setIfPresent: function(obj, prop, val){
        if (isEmpty(val)) return obj;
        obj[prop] = val;
        return obj;
    },
    setStyles: function(elements, styles){
        if (isEmpty(styles)) return;
        elements = getJQObj(elements);
        forLoop(elements, element => {
            loopProps(styles, (prop, value) => {
                if (isEmpty(value)) return;
                element.style[prop] = value;
            });
        });
    },
    showIf: function(condition, element){
        if (Array.isArray(element)){
            forLoop(element, function (el) {
                el = getJQObj(el);
                condition ? el.show() : el.hide();
            });
        }
        else {
            element = getJQObj(element);
            condition ? element.show() : element.hide();
        }
    },
    showInlineIf: function(condition, element){
        element = getJQObj(element);
        condition ? element.css("display", "inline-block") : element.css("display", "none");
    },
    spinIcon: function(element, icon, spin = true){
        addClassIf(spin, element, "fa-spinner fa-spin");
        addClassIf(!spin, element, icon);
    },
    sumArray: function(arr){
        return arr.reduce(function (accumulator, currentValue) {
            return accumulator + currentValue;
        }, 0);
    },
    tagName: function(element){
        element = getJQElement(element);
        try {return element["tagName"].toLowerCase();}
        catch (e){ return "";}
    },
    toArray: function(arrOrStr){
        if (!Array.isArray(arrOrStr)) arrOrStr = [arrOrStr];
        return arrOrStr;
    },
    toCurrency: function(amount, symbol){
        amount = numberOnly(amount);
        if (typeof CompanyCurrencySymbol !== "undefined"){
            symbol = isPresentOr(symbol, CompanyCurrencySymbol, Helpers["currencySymbol"]);
        }
        else symbol = isPresentOr(symbol, Helpers["currencySymbol"]);
        return symbol + amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    },
    toggleClass: function(condition, element, ifTrueClass, ifFalseClass){
        element = getJQObj(element);
        addClassIf(condition, element, ifTrueClass);
        addClassIf(!condition, element, ifFalseClass);
    },
    trimChar: function(str, chars){
        if (isEmpty(str)) return "";
        chars = toArray(chars);
        forLoop(chars, char => {
            char = escapeRegExp(char);
            var regEx = `^[${char}]+|[${char}]+$`;
            regEx = new RegExp(regEx, "g");
            str = str.replace(regEx, '');
        });
        return str;
    },
    trimSlashes: function(path){
        return path.replace(/^[\/]+|[\/]+$/g, '');
    },
    truncate: function(text, length, ellipse){
        if (isEmpty(text)) return "";
        length = isSetOr(length, 300);
        ellipse = isSetOr(ellipse, false);
        if (text.length > length){
            if (ellipse) length -= 3;
            text = text.substring(0, length).trim();
            if (ellipse) text = text + "...";
        }
        return text;
    },
    tryNoCatch: async function(func){
        try {await func();}
        catch(e){}
    },
    uniqueArray: function(array){
        return array.filter(function(element, position) {
            return array.indexOf(element) === position;
        })
    },
    uniqueId: function(){
        return (random5() + random5() + random5()).toUpperCase();
        function random5(){
            return Math.random().toString(36).substr(2, 5);
        }
    },
    URLAppendQS: function(URL, qsParams){
        if (!isString(qsParams)) qsParams = createQueryStr(qsParams);

        var hasQS = URL.indexOf("?") >= 0;
        var separator = hasQS ? "&" : "?";
        return `${URL}${separator}${qsParams}`;

        function createQueryStr(params){
            return Object.keys(params)
                .map(key => [key, params[key]]
                    .map(encodeURIComponent).join('=')).join('&');
        }
    },
    validHex: function(hex){
        if (!isString(hex)) return false;
        var regex = /(?:#)(?:[a-f0-9]{3}|[a-f0-9]{6}|[a-f0-9]{8})\b/ig;
        return regex.test(`#${trimChar(hex, "#")}`);
    },
    validEmail: function(email){
        var emailPattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        return email.match(emailPattern) !== null;
    },
    validPhone: function(phone){
        // US Phone
        var phonePattern = new RegExp(/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/);
        return phone.match(phonePattern) !== null;
    },
    validURL: function(value){
        if (isEmpty(value) || !isString(value)) return false;

        var withoutHTTP = new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi);
        var withHTTP = new RegExp(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/gi);

        return value.match(withHTTP) !== null || value.match(withoutHTTP) !== null;
    },
    valIfJQEvent: function(valOrEvent){
        return ifJQEvent(valOrEvent, getValue(valOrEvent.target));
    },
    waitVarPresent: function(varNamePropStr, object){
        return new Promise(resolve => {
            var interval = setInterval(() => {
                if (isReady()){
                    clearInterval(interval);
                    return resolve();
                }
            }, 5);
        });

        function isReady(){
            if (isPresent(object)){
                return isPresent(getObjProp(object, varNamePropStr));
            }
            else {
                return isPresent(getObjProp(window, varNamePropStr));
            }
        }
    },
    waitVarSet: function(varNamePropStr, object){
        return new Promise(resolve => {
            var interval = setInterval(() => {
                if (isReady()){
                    clearInterval(interval);
                    return resolve();
                }
            }, 5);
        });

        function isReady(){
            var obj = isPresentOr(object, window);
            return isDefined(getObjProp(obj, varNamePropStr));
        }
    },
    waitVarTrue: function(varNamePropStr, object){
        return new Promise(resolve => {
            var interval = setInterval(() => {
                if (isReady()){
                    clearInterval(interval);
                    return resolve();
                }
            }, 5);
        });

        function isReady(){
            var obj = isPresentOr(object, window);
            return getObjProp(obj, varNamePropStr) === true;
        }
    },
    whitelist: function(input, list){
        if (isEmpty(input)) return input;
        if (isString(input)){
            return includes(input, list) ? input : null;
        }

        var output = [];
        if (Array.isArray(input)){
            forLoop(input, element => {
                if (isPlainObject(element)){
                    element = whitelist(element, list);
                    output.push(element);
                }
                else if (list.indexOf(element) >= 0) output.push(element);
            });
            return output;
        }

        output = {};
        forLoop(list, function(prop){
            if (isDefined(input[prop])){
                output[prop] = input[prop];
            }
        });
        return output;
    }
};


// Follow code makes the helpers global
Helpers.loopProps(Helpers, makeHelperGlobal);
function makeHelperGlobal(name, value){
    if (Helpers.isDefined(window[name])){
        // console.warn("Plastic Helpers: " + name + " is already defined");
    }
    else {
        var writable = !Helpers.isFunction(value);
        Object.defineProperty(window, name, {
            enumerable: false,
            configurable: false,
            writable: writable,
            value: value
        });
    }
}